import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { createPortal } from 'react-dom';

import Button from '../../../../shared/_TBComponents/Button';
import Icon from '../../../../shared/_TBComponents/Icon';
import Text from '../../../../shared/_TBComponents/Text';
import {
  useActionMenu, ActionMenuWrapper, ActionMenuContainer, ActionMenuItemButton,
} from './tables/MaxesGoalsTable';

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MoreButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid ${(props) => props.theme.colors.borderMedium};
  border-radius: 4px;
  background: ${(props) => props.theme.colors.surface};
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colors.hover};
    border-color: ${(props) => props.theme.colors.hover};
  }
`;

const MenuItem = styled(ActionMenuItemButton)`
  &:disabled {
    opacity: 0.4;
    cursor: default;
    background: none;
  }
`;

const HistorySectionHeader = ({ onAddMax, onDeleteAll, canDeleteAll }) => {
  const {
    isOpen, menuStyle, menuRef, buttonRef, openMenu, close,
  } = useActionMenu();

  const handleDeleteAll = () => {
    close();
    onDeleteAll();
  };

  return (
    <Header>
      <Text styledTextProps={{ fontSize: '18px', fontWeight: 700 }}>History</Text>
      <Actions>
        <Button
          name='Add Max'
          icon='plus'
          iconColor='#FFF'
          customBorderRadius='4px'
          borderColor='#444444'
          txtColor='#FFF'
          bgColor='#444444'
          styledTextProps={{ fontSize: '14px', fontWeight: 700, letterSpacing: '0.3px' }}
          onClick={onAddMax}
        />
        {onDeleteAll && (
          <ActionMenuWrapper>
            <MoreButton
              ref={buttonRef}
              type='button'
              aria-label='More history actions'
              aria-haspopup='menu'
              aria-expanded={isOpen}
              onClick={openMenu}
            >
              <Icon icon='dots' size={16} color='currentColor' />
            </MoreButton>
            {isOpen && createPortal(
              <ActionMenuContainer ref={menuRef} style={menuStyle} role='menu'>
                <MenuItem
                  type='button'
                  role='menuitem'
                  disabled={!canDeleteAll}
                  title={canDeleteAll ? undefined : 'No maxes to delete'}
                  onClick={handleDeleteAll}
                >
                  <Icon icon='delete' size={16} color='#FF0505' />
                  Delete all maxes
                </MenuItem>
              </ActionMenuContainer>,
              document.body,
            )}
          </ActionMenuWrapper>
        )}
      </Actions>
    </Header>
  );
};

HistorySectionHeader.propTypes = {
  onAddMax: PropTypes.func.isRequired,
  onDeleteAll: PropTypes.func,
  canDeleteAll: PropTypes.bool,
};

HistorySectionHeader.defaultProps = {
  onDeleteAll: null,
  canDeleteAll: false,
};

export default HistorySectionHeader;
